/**
 * Non-deterministic randomness for the web shell (session seeds, local ids,
 * gate challenges, nickname suggestions). Game logic never uses this — the
 * engine draws only from the seeded core Rng.
 */

/** A uniformly random unsigned 32-bit integer (crypto-quality when available). */
export function randomSeed(): number {
  const c = globalThis.crypto;
  if (c && typeof c.getRandomValues === 'function') {
    const buf = new Uint32Array(1);
    c.getRandomValues(buf);
    return buf[0] ?? 0;
  }
  // Very old browsers only; seeds are not security-sensitive.
  return Math.floor(Math.random() * 0x1_0000_0000) >>> 0;
}

/** A random, URL-safe id such as "local-3f9a…" (128 bits of randomness). */
export function randomId(prefix: string): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') return `${prefix}-${c.randomUUID()}`;
  const parts = Array.from({ length: 4 }, () => randomSeed().toString(16).padStart(8, '0'));
  return `${prefix}-${parts.join('')}`;
}
